import { useMutation, useQuery, useQueryClient } from "@tanstack/react-query";
import { clubApi } from "../../../club-api-client";
import type { CreateAnnouncementPayload } from "../../../schemas/announcement";
import { queryKeys } from "../../query-keys";

export function useAnnouncements(clubId: string | null) {
	return useQuery({
		queryKey: queryKeys.clubPortal.announcements(clubId ?? ""),
		queryFn: () => clubApi.announcements.list(clubId!),
		enabled: !!clubId,
	});
}

export function useCreateAnnouncement(clubId: string) {
	const queryClient = useQueryClient();
	return useMutation({
		mutationFn: (payload: CreateAnnouncementPayload) =>
			clubApi.announcements.create(clubId, payload),
		onSuccess: () =>
			queryClient.invalidateQueries({
				queryKey: queryKeys.clubPortal.announcements(clubId),
			}),
	});
}

export function useDeleteAnnouncement(clubId: string) {
	const queryClient = useQueryClient();
	return useMutation({
		mutationFn: (announcementId: string) => clubApi.announcements.delete(clubId, announcementId),
		onSuccess: () =>
			queryClient.invalidateQueries({
				queryKey: queryKeys.clubPortal.announcements(clubId),
			}),
	});
}
